export default __webpack_public_path__ + "static/monotype-helvetica-display-bold-6ec07aad876b6a72db887daf55aff005.woff";